import { render, staticRenderFns } from "./MultipleAssignToAction.vue?vue&type=template&id=328eaeb9"
import script from "./MultipleAssignToAction.vue?vue&type=script&lang=ts"
export * from "./MultipleAssignToAction.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports